export default __webpack_public_path__ + "static/media/img_24.802d77c4.jpg";